import { PaginationQueryDto } from '../../../types/paginationRequestType';
import { StudentWarningsSummaryDataParams } from '../types';

export const useIsQueryEnabled = (
  query: PaginationQueryDto<StudentWarningsSummaryDataParams>,
) => {
  return !!(query?.periodId && query?.schoolId && query?.year);
};
